<style scoped lang="scss">
  .payment-error-page {
    @include padding-y(40px);
    @include padding-x(20px);
    display: flex;
    flex-direction: column;
    align-items: center;

    .error-image {
      img {
        max-width: 200px;
        max-height: 200px;
      }
    }

    .error-title {
      margin-top: 30px;
      text-align: center;
      font-weight: 600;
      font-size: 36px;
    }

    .error-text {
      margin-top: 30px;
      text-align: center;
    }
  }
</style>

<template>
  <div class="payment-error-page">
    <div class="error-image">
      <img :src="$asAppAsset('/images/da-wtf.png')"/>
    </div>
    <div class="error-title">
      {{ $t('payment.somethingWentWrong')}}
    </div>
    <div v-if="errorMessage" class="error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import storage from '@utils/storage'

export default {
  name: 'PaymentErrorPage',
  data() {
    return {
      errorMessage: storage.getItem('da.payin.payment.errorMessage'),
    }
  },
  created() {
    this.$emit('load')
  },
}
</script>
